import { useEffect, useState } from 'react'
import { CustomLoader } from '../Other';

const WhiteLabelPreviewModal = (props) => {

    const [loader, setLoader] = useState(true);

    console.log('previewImage', props.previewImage);




    return (
        <div className='bg-white-ghost d-flex align-items-center justify-content-center position-relative'>
            {/* header logo */}
            <div className='position-absolute top-6px left-130px z-3 d-flex align-items-center gap-1'>
                <img src={props.headerLogoIcon} alt="" width={12} height={12} className='object-fit-cover' />
                <h4 className='mb-0 e-poppins-bold e-font-6 color-yankees-blue'>{props.headerLogoText}</h4>
            </div>


            <img src={props.previewImage} width={404} className='h-auto' alt="" />


            {/* footer logo */}
            <div className='position-absolute bottom-88px left-130px z-3 '>
                <div className='d-flex align-items-center gap-1'>
                    <img src={props.footerLogoIcon} alt="" width={12} height={12} className='object-fit-cover' />
                    <h4 className='mb-0 e-poppins-bold e-font-6 color-yankees-blue'>{props.footerLogoText}</h4>
                </div>
                <p className='mb-0 ps-3  e-poppins-light e-font-3 color-yankees-blue'>{props.footerText}</p>
            </div>
        </div>
    )
}

export default WhiteLabelPreviewModal